import React from 'react';
import { Star, Navigation, CalendarHeart } from 'lucide-react';
import { IHSAN_POINTS, formatPoints } from '../lib/rewards';

// Google Maps centred on the member if they share their location, and a plain
// nearby search if they decline — either way the tap lands on directions.
function openNearestMusollah() {
  const fallback = 'https://www.google.com/maps/search/?api=1&query=musollah+near+me';
  if (!navigator.geolocation) {
    window.open(fallback, '_blank', 'noopener');
    return;
  }
  navigator.geolocation.getCurrentPosition(
    ({ coords }) => {
      window.open(
        `https://www.google.com/maps/search/musollah/@${coords.latitude},${coords.longitude},15z`,
        '_blank',
        'noopener'
      );
    },
    () => window.open(fallback, '_blank', 'noopener'),
    { timeout: 8000 }
  );
}

const Shortcut = ({ label, value, icon: Icon, tint, onClick, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className="rounded-2xl border border-border bg-card px-3 py-2.5 text-left hover:bg-muted/40 transition-colors"
  >
    <span className="block text-[11px] text-muted-foreground leading-none">{label}</span>
    <span className="mt-1.5 flex items-center justify-between gap-1.5">
      <span className="text-sm font-bold text-[#0F172A] leading-tight truncate">{value}</span>
      <span
        className="h-6 w-6 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: tint }}
      >
        <Icon className="h-3.5 w-3.5 text-white" strokeWidth={2.4} />
      </span>
    </span>
  </button>
);

/**
 * The three shortcuts under the category row — the things a member does often
 * enough that they should not have to navigate to find them.
 */
export default function QuickShortcuts({ points = IHSAN_POINTS, onOpenRewards, onScheduleGiving }) {
  return (
    <div className="px-4 pt-3 desktop-shell" data-testid="quick-shortcuts">
      <div className="grid grid-cols-3 gap-2.5">
        <Shortcut
          testId="shortcut-rewards"
          label="Rewards"
          value={`${formatPoints(points)} pts`}
          icon={Star}
          tint="#D4A843"
          onClick={onOpenRewards}
        />
        <Shortcut
          testId="shortcut-musollah"
          label="Nearest"
          value="Musollah"
          icon={Navigation}
          tint="#0F9488"
          onClick={openNearestMusollah}
        />
        <Shortcut
          testId="shortcut-schedule-giving"
          label="Schedule"
          value="a Giving"
          icon={CalendarHeart}
          tint="#E11D48"
          onClick={onScheduleGiving}
        />
      </div>
    </div>
  );
}
